import { render, staticRenderFns } from "./AddGroupModal.vue?vue&type=template&id=170c3cfc&scoped=true&"
import script from "./AddGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupModal.vue?vue&type=style&index=0&id=170c3cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170c3cfc",
  null
  
)

export default component.exports